import Api from './api';

export const getAllWithFilter = async (formData) => {
  let data = []

  await Api.post(`/organizationfieldreportblocks/getall/filter`, formData)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })

  return data
}

export const paginate = async (page, org, search, field) => { 
  let data = []

  let url = `/organizationfieldreportblocks/paginate?page=${page}&org=${org}`
  if (search != '' && field != 0)
    url += `&search=${search}&field=${field}`

  await Api.get(url)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const paginateByOrganization = async (page, orgId, search, field) => { 
  let data = []

  let url = `/organizationfieldreportblocks/organization/paginate?page=${page}&id=${orgId}`
  if (search != '' && field != 0)
    url += `&search=${search}&field=${field}`

  await Api.get(url)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getById = async (id) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getActiveById = async (id) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/${id}/active`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByIdWithoutIncludes = async (id) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/${id}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getActiveByIdWithoutIncludes = async (id) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/${id}/active/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByOrganizationId = async (organizationId) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/organization/${organizationId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getActiveByOrganizationId = async (organizationId) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/organization/${organizationId}/active`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByOrganizationIdWithoutIncludes = async (organizationId) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/organization/${organizationId}/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getActiveByOrganizationIdWithoutIncludes = async (organizationId) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/organization/${organizationId}/active/withoutincludes`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByOrganizationIdAndTitleWithoutIncludes = async (formData, config) => { 
  let data = []
  await Api.post(`/organizationfieldreportblocks/exists/withoutincludes`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getByOrganizationIdAndTitleAndNotIdWithoutIncludes = async (formData, config) => { 
  let data = []
  await Api.post(`/organizationfieldreportblocks/exists/notid/withoutincludes`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const getActiveByOrganizationIdWithoutIncludesOrderBySequence = async (organizationId) => { 
  let data = []
  await Api.get(`/organizationfieldreportblocks/nextsequencelist/organization/${organizationId}/active/withoutincludes/orderbysequence`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getActiveByOrganizationIdAndSequenceAndNotIdWithoutIncludesOrderBySequence = async (formData, config) => { 
  let data = []
  await Api.post(`/organizationfieldreportblocks/nextsequencelist/active/withoutincludes`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const addItem = async (formData, config) => { 
  let data = []
  await Api.post(`/organizationfieldreportblocks`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const updateOrder = async (formData, config) => {
  let data = []
  await Api.put(`/organizationfieldreportblocks/update/order`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const editItem = async (formData, config) => { 
  let data = []
  await Api.put(`/organizationfieldreportblocks`, formData, config)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteItem = async (id) => { 
  let data = []
  await Api.delete(`/organizationfieldreportblocks/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}